import endpoints from "@config/endpoints";
import { session_message, status_type } from "@constants/sessionSiteConstant";
import { getData, postDataJSON, putDataJSON } from "@services/CommonApiService";
import { errorLogger } from "@utils/applicationLogUtils";
import { toast } from "react-toastify";

export const getHealthProviderByFacilitySessionSiteApi = async (facilityId: any, sessionDate: any, sessionId: any = null) => {
    try {
        const payload = {
            facilityId: facilityId,
            sessionDate: sessionDate,
            sessionId: sessionId
        };
        const res = await postDataJSON<any>(`${endpoints.getHealthProviderByFacilitySessionSite}`, payload);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageHpTagged, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getMobiliserByFacilitySessionSiteApi = async (ufIds: any, sessionDate: any, sessionId: any = null) => {
    const payload = {
        ufIds: ufIds,
        sessionDate: sessionDate,
        sessionId: sessionId
    };
    try {
        const res = await postDataJSON<any>(`${endpoints.getMobiliserByFacilitySessionSite}`, payload);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessagemobiliserTagged, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getVillageCoverageSessionSiteApi = async (facilityId: any) => {
    try {
        const res = await getData<any>(`${endpoints.getVillageCoverageSessionSite(facilityId)}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageVillage, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getWardCoverageSessionSiteApi = async (facilityId: any) => {
    try {
        const res = await getData<any>(`${endpoints.getWardCoverageSessionSite(facilityId)}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageWard, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getUserLocationFacilityApi = async () => {
    try {
        const res = await getData<any>(endpoints.getUserLocationFacility);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageFacilityLocation, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getSessionTypeSessionSiteApi = async () => {
    try {
        const res = await getData<any>(endpoints.getSessionTypeSessionSite);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageSessionType, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getSessionHeldAtSessionSiteApi = async () => {
    try {
        const res = await getData<any>(endpoints.getSessionHeldAtSessionSite);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageSessionHeldAt, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getSessionSiteDownloadApi = async () => {
    try {
        const res = await getData<any>(endpoints.getSessionDownload);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageSessionDownload, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getSessionSiteCalenderdataApi = async (payload: any) => {
    try {
        const res = await postDataJSON<any>(endpoints.getSessionCalendarDetailsSessionSite, payload);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageSessionCalender, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getSessionSiteCalenderSearchdataApi = async (searchTerm: any) => {
    try {
        const res: any = await postDataJSON(
            `${endpoints.getSessionBySearch}/${searchTerm}`,
            { fromDate: '', toDate: '' },
        );
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageSessionCalenderSearch, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getSessionDetailsByDateSessionSiteApi = async (date: any) => {
    try {
        const response = await postDataJSON<any>(
            endpoints?.getSessionDetailsByDateSessionSite,
            { sessionPlannedDate: date },
        );
        if (response && (response.data || response.data.length > 0)) {
            return response;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageSessionDetailsByDate, {
            position: 'top-center',
        });
        errorLogger(error?.response?.data||error?.response||error);
    }


};

export const createSessionApi = async (payload: any) => {
    try {
        const response: any = await postDataJSON<any>(`${endpoints.createSessionSite}`, payload);
        if (response) {
            return response;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageCreateMessage, {
            position: 'top-center',
        });
        errorLogger(error?.response?.data||error?.response||error);
    }
};

export const updateSessionApi = async (payload: any, sessionId: any) => {
    try {
        const response: any = await putDataJSON<any>(`${endpoints.updateSessionSite(sessionId)}`, payload);
        if (response) {
            return response;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageUpdateMessage, {
            position: 'top-center',
        });
        errorLogger(error?.response?.data||error?.response||error);
    }
};

export const getSessionDetailByIdApi = async (id: any) => {
    try {
        const res = await getData<any>(`${endpoints.getViewSessionById}/${id}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageSessionDetails, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const getSessionDetailStatusApi = async () => {
    try {
        const res = await getData<any>(`${endpoints.getSessionStatus}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageSessionStatus, {
            position: "top-center"
        });
        errorLogger(error?.response?.data||error?.response||error);
    };
};

export const statusSessionApi = async (statusData: any) => {
    try {
        const payload = {
            sessionId: statusData.sessionId,
            statusId: statusData.statusId
        };
        const response: any = await putDataJSON<any>(`${endpoints.sesionStatusModification}`, payload);
        if (response) {
            return response;
        }
    } catch (error: any) {
        toast.error(statusData.statusCode == status_type.cancle.session_status_code ? session_message.errorMessagecancleStatusMessage : session_message.errorMessageconfirmStatusMessage, {
            position: 'top-center',
        });
        errorLogger(error?.response?.data||error?.response||error);
    }
};

export const deleteSessionApi = async (payload: any) => {
    try {
        const response: any = await postDataJSON<any>(`${endpoints.deleteSession}`, payload);
        if (response) {
            toast.success(session_message.sessionDeletedSuccessMessage, {
                position: 'top-center',
            });
            return response;
        }
    } catch (error: any) {
        toast.error(session_message.errorMessageDeleteStatusMessage, {
            position: 'top-center',
        });
        errorLogger(error?.response?.data||error?.response||error);
    }
};